import { all, fork } from 'redux-saga/effects';
import { watchCancelSubscription, watchGetSubscriptionById, watchGetSubscriptions } from './subscription.saga';

function* RecurringsSaga() {
    yield all([fork(watchGetSubscriptions), fork(watchGetSubscriptionById), fork(watchCancelSubscription)]);
}

export default RecurringsSaga;
